import React, { useContext } from "react";
import { InlineMath } from "react-katex";
import { ThemeContext } from "../context/ThemeContext";

export default function TrigValuesTable({ highlightFunc, highlightAngle }) {
  const { theme } = useContext(ThemeContext);
  const borderColor = theme === "light" ? "black" : "white";
  const highlightColor = "#f5b04d"; // delikatny pomarańczowy, neutralny dla obu motywów

  const angles = [0, 30, 45, 60, 90];
  const sin = ["0", "\\dfrac{1}{2}", "\\dfrac{\\sqrt{2}}{2}", "\\dfrac{\\sqrt{3}}{2}", "1"];
  const cos = ["1", "\\dfrac{\\sqrt{3}}{2}", "\\dfrac{\\sqrt{2}}{2}", "\\dfrac{1}{2}", "0"];
  const tan = ["0", "\\dfrac{\\sqrt{3}}{3}", "1", "\\sqrt{3}", "\\text{nie istnieje}"];

  const cellStyle = {
    border: `1px solid ${borderColor}`,
    padding: "6px",
    textAlign: "center",
  };

  const highlightCell = {
    backgroundColor: highlightColor,
    fontWeight: "bold",
  };

  const headerCellStyle = {
    ...cellStyle,
    width: "80px",
  };

  const firstColStyle = {
    ...cellStyle,
    width: "80px",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "bold",
  };

  const getCellStyle = (func, angle) => {
    const angleIndex = angles.indexOf(angle);
    const isHighlighted = func === highlightFunc && angle === highlightAngle;
    return {
      ...(angleIndex === angles.length - 1 ? headerCellStyle : cellStyle),
      ...(isHighlighted ? highlightCell : {}),
    };
  };

  const getHeaderStyle = (angle) => {
    const isHighlighted = angle === highlightAngle;
    return {
      ...cellStyle,
      ...(isHighlighted ? highlightCell : {}),
    };
  };

  const getRowLabelStyle = (func) => {
    const isHighlighted = func === highlightFunc;
    return {
      ...firstColStyle,
      ...(isHighlighted ? highlightCell : {}),
    };
  };

  return (
    <table
      style={{
        marginTop: "1rem",
        borderCollapse: "collapse",
        width: "100%",
        fontSize: "14px",
        border: `1px solid ${borderColor}`,
      }}
    >
      <thead>
        <tr>
          <th style={firstColStyle}></th>
          {angles.map((a) => (
            <th key={a} style={getHeaderStyle(a)}>
              <InlineMath math={`${a}^\\circ`} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={getRowLabelStyle("sin")}>
            <InlineMath math={`\\sin \\alpha`} />
          </td>
          {sin.map((val, i) => (
            <td key={i} style={getCellStyle("sin", angles[i])}>
              <InlineMath math={val} />
            </td>
          ))}
        </tr>
        <tr>
          <td style={getRowLabelStyle("cos")}>
            <InlineMath math={`\\cos \\alpha`} />
          </td>
          {cos.map((val, i) => (
            <td key={i} style={getCellStyle("cos", angles[i])}>
              <InlineMath math={val} />
            </td>
          ))}
        </tr>
        <tr>
          <td style={getRowLabelStyle("tan")}>
            <InlineMath math={`\\tan \\alpha`} />
          </td>
          {tan.map((val, i) => (
            <td key={i} style={getCellStyle("tan", angles[i])}>
              <InlineMath math={val} />
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
}
